import type { OptionValue } from '@tempmee/core';
import { ParkingCostEnum, ParkingTypeEnum } from '~/models/ParkingInformation';

// Office-profile field options shared by the sign-up office setup step, the
// shift-request missing-info modal (GOTU-12579) and Location settings (GOTU-20014).
// None offers 'N/A': the missing-info gate counts a stored 'N/A' as unanswered.

export const TIME_PER_PATIENT_OPTIONS: OptionValue<string>[] = [
  '30 min',
  '45 min',
  '1 hr',
  '1.5 hr',
  '2+ hr',
].map((v) => ({ label: v, value: v }));

export const NUMBER_OF_OPERATORIES_OPTIONS: OptionValue<string>[] = [
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  '10+',
].map((v) => ({ label: v, value: v }));

export const YES_NO_OPTIONS: OptionValue<string>[] = [
  { label: 'Yes', value: 'yes' },
  { label: 'No', value: 'no' },
];

/** A parking cost as typed: dollars with at most two decimals. */
export const PARKING_COST_PATTERN = /^\d+(\.\d{0,2})?$/;

export const COST_UNIT_OPTIONS: OptionValue<string>[] = [
  { label: 'Hour', value: ParkingCostEnum.Hourly },
  { label: 'Day', value: ParkingCostEnum.Daily },
];

/** Parking types for when the metadata's `parkingTypes` haven't loaded: the `ParkingTypeEnum` values. */
export const PARKING_TYPE_FALLBACK: OptionValue<string>[] = Object.values(ParkingTypeEnum).map(
  (value) => ({ label: value, value }),
);

/** Parking types from the metadata's `parkingTypes`, or the fallback when they haven't loaded. */
export const toParkingTypeOptions = (
  parkingTypesFromMetadata?: string[] | null,
): OptionValue<string>[] =>
  parkingTypesFromMetadata?.length
    ? parkingTypesFromMetadata.map((t) => ({ label: t, value: t }))
    : PARKING_TYPE_FALLBACK;
